// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_aV2","cls2":"LoggedOutDiscoveryPage-cls2_T2a LoggedOutDiscoveryPage-cls1_aV2"};